module.exports = __webpack_public_path__ + "img/1453760605.933263fb.jpg";